import FlightTable from './FlightTable';

export default FlightTable;
